import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllCountriesEndpoint } from "~/modules/country/api/country/countryApiEndpoints.ts";
import type { Country } from "~/modules/country/api/country/countryTypes.ts";

export const getAllCountries = (): AxiosApiResponsePromise<Country[]> => axiosApi.get(getAllCountriesEndpoint);
